import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

export const PREVIEW_BANNER_TEXT = 'Ambiente de teste — dados e pagamentos de teste';

// Inlined by Metro at build time. Only the web-preview-staging CI job sets it,
// so the production web build and the app bundles never render this banner.
export function isPreviewBannerEnabled(): boolean {
  return process.env.EXPO_PUBLIC_PREVIEW_BANNER === '1';
}

export function PreviewBanner() {
  if (!isPreviewBannerEnabled()) return null;

  return (
    <View style={styles.container} testID="preview-environment-banner" accessibilityRole="alert">
      <Text variant="labelLarge" style={styles.text}>
        {PREVIEW_BANNER_TEXT}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: '#B45309',
  },
  text: {
    color: '#FFFFFF',
    textAlign: 'center',
    fontWeight: '700',
  },
});
